module.exports = __webpack_public_path__ + "assets/vehicle_map_crossover.7695f776.svg";